var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Button, HoverOverlay } from '../index';
function FilterToggle(props) {
    var negate = props.negate, onNegate = props.onNegate, exists = props.exists, onExists = props.onExists, disabled = props.disabled;
    var existsButton = (_jsx(Button, __assign({ disabled: disabled, active: exists, className: "tol-filter-button exists", onClick: function () { return onExists(exists); } }, { children: _jsx("div", __assign({ className: 'icon' }, { children: "\u2203" })) })));
    var negateButton = (_jsx(Button, __assign({ disabled: disabled, active: negate, className: "tol-filter-button negate", onClick: function () { return onNegate(negate); } }, { children: _jsx("div", __assign({ className: 'icon' }, { children: "\u00AC" })) })));
    return (_jsxs("div", __assign({ className: 'tol-filter-button-group' }, { children: [!disabled ?
                _jsx(HoverOverlay, __assign({ contents: "Filter by values that exist. This will exclude empty/null values.", followCursor: true }, { children: existsButton }))
                : existsButton, !disabled ?
                _jsx(HoverOverlay, __assign({ contents: "Negate this filter.", followCursor: true }, { children: negateButton }))
                : negateButton] })));
}
export default FilterToggle;
